import { Carousel, CarouselContent, CarouselDots, CarouselItem } from '@natu/ui/Carousel';
import { isArrayWithLength } from '@natu/utils/isArrayWithLength';

import { BlokItem, type SBProps, sbEditable } from '../../../../utils';
import { SBCarouselTestimonialItem, type TestimonialItem } from './SBCarouselTestimonialItem';

interface SBCarouselTestimonialProps {
  autoplayDelay?: number;
  disableCustomCursor?: boolean;
  testimonials?: Array<BlokItem & TestimonialItem>;
}

export const SBCarouselTestimonial = ({ blok }: SBProps<SBCarouselTestimonialProps>) => {
  const { autoplayDelay, disableCustomCursor, testimonials } = blok;

  const carouselOptions = {
    opts: { loop: true },
    ...(autoplayDelay && { autoplay: true, autoplayDelay }),
  };

  if (!isArrayWithLength(testimonials)) return null;

  return (
    <Carousel disableCustomCursor={disableCustomCursor} {...carouselOptions} {...sbEditable(blok)}>
      <CarouselContent className="items-stretch">
        {testimonials.map(testimonial => (
          <CarouselItem key={testimonial._uid}>
            <SBCarouselTestimonialItem item={testimonial} {...sbEditable(testimonial)} />
          </CarouselItem>
        ))}
      </CarouselContent>
      <nav className="relative left-6 top-[-36px] lg:top-[-32px] xl:top-[-68px]">
        <CarouselDots layoutID={blok._uid} theme="primary" className="justify-start" />
      </nav>
    </Carousel>
  );
};
